export const MIXPANEL_TOKEN = process.env.VUE_APP_MIXPANEL_TOKEN;
export const ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT;
export const DEV_URL = process.env.VUE_APP_DEV_URL;
export const PROD_URL = process.env.VUE_APP_PROD_URL;
